import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { Divider } from "@material-ui/core";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import styled from "styled-components";
import { useSelector } from "react-redux";
import qs from "query-string";
import UPIDeposit from "./UPIDeposit";
import INRBalanceCard from "./INRBalanceCard";
import DepositCard from "../../components/DepositCard";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { useQuery } from "react-query";

export default function INRDeposit() {
  const isMobile = useResizer();
  const toggleValues = [
    {
      id: "net-banking",
      value: isMobile ? "Net Banking" : "Instant Deposit (IMPS, RTGS & NEFT)",
    },
    { id: "upi", value: isMobile ? "UPI" : "Instant Deposit with UPI" },
  ];
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();

  const darkMode = useSelector((state) => state.trading.DARK_MODE);

  const { data, error } = useSWR(`/v1/transfers/depositConfig`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  useEffect(() => {
    if (error?.status === 401) {
      bannedTimeout("timeout");
    } else if (error?.status === 403) {
      bannedTimeout("banned");
    }
  }, [error]);

  const [filterType, setFilterType] = useState(() => {
    return setDefaultType();
  });

  const [limit, setLimit] = useState({
    min: 500,
    max: 2000000,
  });

  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);

  function setDefaultType() {
    const obj = qs.parse(location.search);
    if (!obj?.type) {
      //commenting out for new deposit page design. this removes the default query param that gets added
      // history.replace({ search: `type=${toggleValues[0].id}` });
      // return toggleValues[0].id;
    } else {
      const checkType = (ele) => ele.id === obj.type;

      if (toggleValues.some(checkType)) {
        setTimeout(() => setFilterType(obj.type), 1000);
        return obj.type;
      }
    }
  }

  // function getCurrentScreen(type) {
  //   switch (type) {
  //     case "net-banking":
  //       return (
  //         <>
  //           <div className={classes.gridContainer}>
  //             <INRBalanceCard></INRBalanceCard>
  //             <Divider />
  //             <div className={classes.subContainer}>
  //               <p style={{ color: "#92989B" }}>
  //                 <span style={{ color: "red", fontWeight: "bold" }}>
  //                   {"Note:" + "\xa0"}
  //                 </span>{" "}
  //                 The INR deposit amount should be greater than ₹{limit.min}.
  //               </p>
  //             </div>
  //             <Divider />
  //             <div className={classes.subContainer}>
  //               <div className={classes.flexContainer}>
  //                 <FaPiggyBank style={{ fontSize: "20px", color: "#3AC4AB" }} />
  //                 <p
  //                   style={{
  //                     color: "#3AC4AB",
  //                     fontSize: "16px",
  //                     fontWeight: "bold",
  //                     marginLeft: "15px",
  //                   }}
  //                 >
  //                   Account details for Instant Deposit
  //                 </p>
  //               </div>
  //               <div
  //                 className={classes.flexContainer}
  //                 style={{ marginTop: "5px" }}
  //               >
  //                 <p className={classes.ptitle}>Beneficiary Name</p>
  //                 <p className={`${classes.pvalue} ml-3`}>
  //                   Defacto Technologies
  //                 </p>
  //                 <div className={classes.grow} />
  //                 <MdContentCopy
  //                   className={classes.copyIcon}
  //                   onClick={() => {
  //                     navigator.clipboard.writeText("Defacto Technologies");
  //                     handleClickAlert("success", "Copied!");
  //                   }}
  //                 />
  //               </div>
  //               <div
  //                 className={classes.flexContainer}
  //                 style={{ marginTop: "5px" }}
  //               >
  //                 <p className={classes.ptitle}>Account Number</p>
  //                 <p className={`${classes.pvalue} ml-3`}>{accountNum}</p>
  //                 <div className={classes.grow} />
  //                 <MdContentCopy
  //                   className={classes.copyIcon}
  //                   onClick={() => {
  //                     navigator.clipboard.writeText(accountNum);
  //                     handleClickAlert("success", "Copied!");
  //                   }}
  //                 />
  //               </div>
  //               <div
  //                 className={classes.flexContainer}
  //                 style={{ marginTop: "5px" }}
  //               >
  //                 <p className={classes.ptitle}>IFSC</p>
  //                 <p className={`${classes.pvalue} ml-3`}>{ifsc}</p>
  //                 <div className={classes.grow} />
  //                 <MdContentCopy
  //                   className={classes.copyIcon}
  //                   onClick={() => {
  //                     navigator.clipboard.writeText(ifsc);
  //                     handleClickAlert("success", "Copied!");
  //                   }}
  //                 />
  //               </div>
  //               <div
  //                 className={classes.flexContainer}
  //                 style={{ marginTop: "5px" }}
  //               >
  //                 <p className={classes.ptitle}>Remark</p>
  //                 <p className={`${classes.pvalue} ml-3`}>{remark}</p>
  //                 <div className={classes.grow} />
  //                 <MdContentCopy
  //                   className={classes.copyIcon}
  //                   onClick={() => {
  //                     navigator.clipboard.writeText(remark);
  //                     handleClickAlert("success", "Copied!");
  //                   }}
  //                 />
  //               </div>
  //             </div>
  //             <Divider />
  //             <div className={classes.subContainer}>
  //               <div
  //                 className={classes.flexContainer}
  //                 style={{
  //                   borderBottomStyle: "solid",
  //                   paddingBottom: "5px",
  //                   borderColor: "red",
  //                   borderWidth: "2px",
  //                 }}
  //               >
  //                 <BsExclamationCircle
  //                   style={{ fontSize: "20px", color: "red" }}
  //                 />
  //                 <p
  //                   style={{
  //                     color: "red",
  //                     fontWeight: "bold",
  //                     marginLeft: "15px",
  //                   }}
  //                 >
  //                   Information
  //                 </p>
  //               </div>
  //               <ol
  //                 style={{
  //                   marginTop: "10px",
  //                   marginLeft: "25px",
  //                   color: "#9fa1a0",
  //                 }}
  //               >
  //                 <li>Zero Fee Deposits.</li>
  //                 <li>Use only registered bank accounts for Deposits.</li>
  //                 <li>
  //                   Deposit only to the account details visible on your INR
  //                   deposit screen as all users have a different Virtual account
  //                   number.
  //                 </li>
  //               </ol>
  //             </div>
  //           </div>
  //         </>
  //       );
  //       {
  //         /* Commenting out UPI feature */
  //       }
  //     // case "upi":
  //     //   return <UPIDeposit></UPIDeposit>;
  //     default:
  //       return <></>;
  //   }
  // }

  const inrConfig = useQuery("inrconfig", async () => {
    return await fetcher("/v1/inrConfig");
  });
  const userConfig = useQuery(["userconfig"], async () => {
    return await fetcher("/v1/userConfigs");
  });
  return (
    <div className={classes.container}>
      <h1 className="mb-3">Deposit INR</h1>
      <p className="font-light mb-5">
        <span
          className="underline cursor-pointer"
          onClick={() => {
            if (isMobile) {
              history.push(`/wallet/inr`);
            } else {
              history.push(`/wallet/inr`);
            }
          }}
        >
          Wallet
        </span>{" "}
        {">"}
        <span style={{ color: "#3AC4AB" }}> Deposit INR</span>
      </p>
      {/* Commenting out UPI feature */}
      {/* <div>
        <ToggleSwitch
          values={toggleValues}
          selected={filterType}
          className="mr-5"
          darkMode={darkMode}
          onChange={(val) => {
            setFilterType(val);
          }}
        />
      </div> */}

      {/* {getCurrentScreen(filterType)} */}
      <div>
        <div className="mb-2">
          <INRBalanceCard></INRBalanceCard>
        </div>
        <Divider></Divider>
        <div className="mb-2"></div>
        {/* <DepositCard
          to="/inr/deposit/instant"
          content={
            <>
              <div className="font-light mb-1">
                IMPS, RTGS & NEFT | Automatic | UPI Apps (BHIM, Google Pay, etc
                not supported yet)
              </div>
              <div className="font-bold">
                Fee: 0% | Minimum Deposit Amount: 500 INR
              </div>
            </>
          }
          title="Instant Deposit"
          status={data?.instantActive ? "ACTIVE" : "PAUSED"}
        ></DepositCard> */}
        {/* <DepositCard
          to="/inr/deposit/upi"
          content={
            <>
              <div className="font-light mb-1">
                Deposit via UPI apps (BHIM, GPay, Paytm etc.)
              </div>
              <div className="font-bold">
                Minimum Deposit: 500 INR | 0 Fee on UPI deposits for a limited
                period.
              </div>
            </>
          }
          title="Instant UPI Deposit"
          status={data?.upiActive ? "ACTIVE" : "PAUSED"}
        ></DepositCard> */}
        <DepositCard
          title="Direct Bank Deposit"
          to="/inr/deposit/direct"
          content={
            !userConfig?.data?.id ? (
              <>
                <div className="font-light mb-1">
                  INR Deposits are temporarily paused; kindly contact the
                  support team via Chat to check if your account is eligible for
                  INR Deposits.
                </div>
              </>
            ) : (
              <>
                <div className="font-light mb-1">
                  IMPS, RTGS & NEFT | Manual | Max 59 mins Deposit Guarantee
                  (10AM-10:00PM)
                </div>{" "}
                <div className="font-light mb-1">
                  UPI Deposits are NOT Supported, only deposit via
                  IMPS/NEFT/RTGS
                </div>
                <div className="font-bold">
                  {`Fee: 0% | Maximum Deposit limit: ${
                    inrConfig?.data?.maxDeposit || 0
                  } INR, Minimum ${inrConfig?.data?.minDeposit || 0} INR.`}
                </div>
              </>
            )
          }
          status={data?.directBankActive ? "ACTIVE" : "PAUSED"}
        ></DepositCard>{" "}
        {/* <DepositCard
          title="MobiKwik Wallet"
          content={
            <>
              <div className="font-light mb-1">
                Automatic | Cards | Netbanking | MobiKwik Wallet
              </div>
              <div className="font-bold">
                Fee: 1.77% of Total Amount | Minimum Deposit Amount: INR 1
              </div>
            </>
          }
          status={data?.mobikwikActive ? "ACTIVE" : "PAUSED"}
          // status={"PAUSED"}
        ></DepositCard>{" "} */}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    width: "35%",
    color: "#9fa1a0",
    fontSize: "14px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#92989B",
  },
  copyIcon: {
    fontSize: "20px",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function ToggleSwitch(props) {
  const [selected, setSelected] = useState(props.selected);

  const handleChange = (val) => {
    setSelected(val);
    props.onChange(val);
  };

  const selectionStyle = () => {
    return {
      left: `${
        (props.values
          .map(function (e) {
            return e.id;
          })
          .indexOf(selected) /
          2) *
        100
      }%`,
    };
  };
  return (
    <Switch {...props}>
      {props.values.map((val) => {
        return (
          <Link to={"/inr/deposit?type=" + val.id}>
            <span>
              <ConcealedRadio value={val.id} selected={selected} />
              <ClickableLabel
                title={val.value}
                id={val.id}
                onChange={handleChange}
              />
            </span>
          </Link>
        );
      })}
      <SwitchSelection style={selectionStyle()} darkMode={props.darkMode} />
    </Switch>
  );
}

const ClickableLabel = ({ title, onChange, id }) => (
  <SwitchLabel onClick={() => onChange(id)} className={id}>
    {title}
  </SwitchLabel>
);

const ConcealedRadio = ({ value, selected }) => {
  return <SwitchRadio type="radio" name="switch" checked={selected == value} />;
};

const Switch = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  color: ${(props) => (props.darkMode ? "#fff" : "#000")};
  background-color: ${(props) => (props.darkMode ? "#0F1421" : "#F1F1F1")};
  border-radius: 3px;
`;

const SwitchRadio = styled.input`
  display: none;
`;

const SwitchSelection = styled.span`
  display: block;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  width: 50%;
  height: 100%;
  background-color: ${(props) => (props.darkMode ? "#141C2E" : "#FDFDFD")};
  border-radius: 3px;
  transition: left 0.25s ease-out;
`;

const SwitchLabel = styled.label`
  position: relative;
  z-index: 2;
  float: left;
  width: 50%;
  // line-height: 26px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  ${SwitchRadio}:checked + & {
    transition: all 0.15s ease-out;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08));
    border-bottom: 3px solid #3ac4ab;
  }
`;
